import { render, staticRenderFns } from "./CanalesModalidades.vue?vue&type=template&id=60617eeb"
import script from "./CanalesModalidades.vue?vue&type=script&lang=js"
export * from "./CanalesModalidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports